import { API_ROOT } from "./Api-config";

// MSAL Configuration
const msalConfig = {
    auth: {
      clientId: API_ROOT.microsoftLoginClientId, // Replace with your Azure AD App Client ID
      authority: `https://login.microsoftonline.com/${API_ROOT.microsoftLoginTenantId}`, // Replace with your tenant ID
      redirectUri: API_ROOT.microsoftredirectUri, // Update this with your redirect URI
    },
  };

export default msalConfig